import { Hint } from './Hint'
import { BasicInput } from './BasicInput'
import useT from '@hooks/useTranslation'

function HintInput (props) {
    const { hint, label, name, t, ...inputProps } = props || {}
    const labelText = useT(label || t)
    const input = <BasicInput label={labelText} name={name} {...inputProps} />

    return hint
        ? <Hint
            name={name}
            placeholder={inputProps.placeholder}
            variantOverride={props.type == 'number' ? 'Desktop' : undefined}
            {...hint}
          >{input}</Hint>

        : input
}

export {
    HintInput,
}